export const validatePassword = (password: string): string => {
  let error = '';

  if (password.length < 8) {
    error = 'Password must be at least 8 characters long';
  }

  return error;
};

export const validateConfirmation = (
  password: string,
  confirmation: string,
): string => {
  let error = '';

  if (password !== confirmation) {
    error = 'Passwords do not match';
  }

  return error;
};

export const meetsMinLength = (password: string): boolean =>
  password.length >= 8;

export const meetsSpecialCharacter = (password: string): boolean =>
  /[^a-zA-Z0-9]/.test(password);

export const PASSWORD_REQUIREMENTS = [
  { key: 'minLength', label: 'At least 8 characters', check: meetsMinLength },
  {
    key: 'specialChar',
    label: 'Your password must contain at least 1 special character',
    check: meetsSpecialCharacter,
  },
] as const;

export const allRequirementsMet = (password: string): boolean =>
  PASSWORD_REQUIREMENTS.every(({ check }) => check(password));
